
/**
 *  This class contains the "main palette" of the "general" widget, a set of colors which will be used to style its main graphic components 
   * (IE. title lables,sub-titles lables,  general background...).
   * 
   * Each property is a string containing the code (EITHER exadecimal OR rgba) for a color, which will be used inside the specific ionic component
   * (IE. widget-***.component, counter-header.component, widget-counter-***.component and its other inner components) to populate specific scss 
   * variables inserted in specific scss class (defined in global scss file "shared-global.scss" for this reason).
   * 
   * If the specific type of widget offers further customizable graphical elements, then additional properties shall be defned in specific
   * descendent classes.
 */
export class SmartPaletteGeneral {
  public iconColorLighter: string = "";
  public iconColorDarker: string = "";
  public sliderColorLighter: string = "";
  public sliderColorDarker: string = "";

  constructor() { }
}


/**
 *  This class contains the "main palette" of the "counter-type" widget, a set of colors which will be used to style its main graphic components 
   * (IE. title lables,sub-titles lables,  general background...).
   * 
   * Each property is a string containing the code (EITHER exadecimal OR rgba) for a color, which will be used inside the specific ionic component
   * (IE. widget-***.component, counter-header.component, widget-counter-***.component and its other inner components) to populate specific scss 
   * variables inserted in specific scss class (defined in global scss file "shared-global.scss" for this reason).
 */
export class SmartPaletteCounter extends SmartPaletteGeneral {

  public backgroundColor: string = "";
  public mainLableColor: string = "";
  public secondaryLableColor: string = "";
  public bandDoubleBackground: string = "";
  public bandTripleBackground: string = "";
  public expandableSpanColor: string = "";
  public expandableSpanBackground: string = "";
  public graphBar1Color: string = "";
  public graphBar2Color: string = "";
  public graphPointMin: string = "";
  public graphLineMin: string = "";
  public graphPointMax: string = "";
  public graphLineMax: string = "";
  public buttonBackground: string = "";
  public buttonTextColor: string = "";

  constructor() {
    super();
  }
}


